import Http from '../Core/Http';
export default class My extends Http {
  constructor(config) {
    super(config);
  }
  //用户Login/GetSessionId
  GetSessionId() {
    return this._get('/api/Login/GetSessionId')
  }

  QueryUser(sessionId) {
    return this._get('/api/user/QueryUser', {
      sessionId: sessionId
    });
  }

  //缴费记录GET/api/Bill/GetPaymentRecordList
  GetpaymentRecordlistV2(params) {
    return this._get('/api/Bill/GetpaymentRecordlistV2', params);
  }

  //住院预缴列表POST/api/Interaction/GetPrepayList
  GetPrepayList(data) {
    return this._post('/api/Interaction/GetPrepayList', null, data);
  }

  //获取住院费用查询-分类汇总POST/api/Interaction/GetInpatientExpensesGroupByCategory
  GetExpensesGroupByCategoryV2(data) {
    return this._post('/api/Interaction/GetExpensesGroupByCategoryV2', null, data);
  }

  //获取住院费用查询---每日清单明细POST/api/Interaction/GetExpensesDetails
  GetInpatientFeeByDay(data) {
    return this._post('/api/Interaction/GetInpatientFeeByDay', null, data);
  }

  //病人在院基本信息查询post、GetHospitalizationInfo
  GetHospitalizationInfo(data) {
    return this._post('/api/Interaction/GetHospitalizationInfo', null, data);
  }

  //获取检查报告列表POST//api/Interaction/GetInspectionReportList
  GetInspectionReportList(data) {
    return this._post('/api/Interaction/GetInspectionReportList', null, data);
  }

  //获取检查报告详情/api/Interaction/GetInspectionReport
  GetInspectionReport(id) {
    return this._post('/api/Interaction/GetInspectionReport', null, {
      ReportId: id
    });
  }

  //获取检验报告列表POST/api/Interaction/GetLaboratoryReportListV2
  GetLaboratoryReportListV2(data) {
    return this._post('/api/Interaction/GetLaboratoryReportListV2', null, data);
  }

  //获取检验报告详情POST/api/Interaction/GetLaboratoryReport
  GetLaboratoryReport(data) {
    return this._post('/api/Interaction/GetLaboratoryReport', null, data);
  }

  // 健康卡绑定验证接口,从his判断是否存在用户信息
  IsHealthCardExists(data) {
    return this._post('/api/Interaction/IsHealthCardExists', null, data);
  }

  // 添加健康卡
  AddHealthCardInfo(data) {
    return this._post('/api/HealthCard/Add', null, data);
  }

  // 获取绑定得健康卡
  GetBindHealthCard(id) {
    return this._get('/api/HealthCard/GetBindHealthCard', {
      userId: id
    });
  }

  // 在线建档
  OnlineFile(data) {
    return this._post('/api/Interaction/OnlineFile', null, data);
  }

  // 删除健康卡
  DelHealthCardInfo(id) {
    return this._get('/api/HealthCard/Delete', {
      id: id
    });
  }

}



// WEBPACK FOOTER //
// ./src/lib/PMA/My.js